<template>
  <div >
     <h2>龙吟山庄</h2>
     <p style="margin-bottom:20px">龙吟山庄坐落在中原名镇-下汤镇.地址为平顶山市鲁山县下汤镇高速口五棵树方向3公里处,内有住宿,野味,养殖,娱乐等项目</p>
       <baidu-map :center="center" :zoom="zoom" @ready="handler" class="bm-view"><bm-marker :position="{lng: 112.674674, lat: 33.711967}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      <bm-label content="龙吟山庄" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}"/>
    </bm-marker>

  </baidu-map>
  </div>
</template>

<script>

export default {
    name: 'dt',
    data() {
        return {
            center: {lng: 0, lat: 0},
            zoom: 3
        }
    },
    async created() {

    },
    methods: {
        handler ({BMap, map}) {
            console.log(BMap, map)
            this.center.lng = 112.674674
            this.center.lat = 33.711967
            this.zoom = 15
        }
    }
}
</script>

<style lang="scss" scoped>
.bm-view {
  width: 80vw;
  height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/dt.vue